import ActBtn from 'components/buttons/ActBtn'
import OrderContext from 'pages/Order/_context'
import { useContext } from 'react'
import { Badge } from 'react-bootstrap'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { assignDriver } from 'state/Orders'
import { Alerts } from 'utils'

export default function RequestDriverRow({ details, onAssign }) {
	const { t }    = useTranslation()
	const dispatch = useDispatch()
	const order    = useContext(OrderContext)

	async function doAssignDriver() {
		await dispatch(assignDriver(order.id, details.name, details.id))
			.then(() => Alerts.success(
				<Trans>Done! The driver will be arriving in <b>around {{ x: details.pickupDuration }} min.</b></Trans>
			))
			.finally(onAssign)
	}

	//TODO make this table responsive if adding more columns, it will be no good on small screens!
	return <tr role="row">
		<td>
			<ActBtn type="submit" block variant="success" className={`driver-${details.key}`}
			        action={doAssignDriver} texts={[details.name, t('Requesting'), t('Requested!')]}/>
		</td>
		{/* For now we are not showing fees */}{/*<td><small>${thirdParty.fee}</small></td>*/}
		<td className="pickup-time">
			{details.localPickupTime}{' '}
			<Badge variant="info">{t('in {{x}} min', { x: details.pickupDuration })}</Badge>
		</td>
	</tr>
}
